import ClockIcon from '../../svg/ClockIcon'
import { ReactComponent as Headphones } from '../../svg/normalSvgs/Headphones.svg'
import { ReactComponent as LikeIcon } from '../../svg/normalSvgs/LikeIcon.svg'
import '../../styles/IssueSolutionMeta.css'

export default function IssueSolutionMeta({ estimatedTime, numOfLikes, hasSound, liked }) {
    const displayedNumberOfLikes = numOfLikes > 99 ? `99+` : numOfLikes
    const likeColor = liked ? '#153c4f' : '#c4c4c4'
    const icon = hasSound ? <Headphones className="mr-4" /> : <ClockIcon color="#153c4f" className="mr-4" />

    return (
        <div className="issue-solution-meta">
            <div className="issue-solution-meta-icon-left items-center">
                {icon}
                <span className="inline-block solutions-meta-text">{estimatedTime}</span>
            </div>
            <div className=" mx-8"></div>
            <div className="issue-solution-meta-icon-right items-center">
                <LikeIcon color={likeColor} />
                <span className={`inline-block ml-5 solutions-meta-like-text ${liked ? 'liked-color' : 'disliked-color'}`}>{displayedNumberOfLikes}</span>
            </div>
        </div>
    )
}
